import { createResourceApi } from './resourceApi';

/** Connected apps, members, wallets and points. */
export const connectedAppsApi = createResourceApi('/connected-apps');
export const integrationKeysApi = createResourceApi('/integration-keys');
export const appMembersApi = createResourceApi('/app-members');
export const walletsApi = createResourceApi('/wallets');
export const pointLedgerEntriesApi = createResourceApi('/point-ledger-entries');
export const earningRulesApi = createResourceApi('/earning-rules');
export const earningEventsApi = createResourceApi('/earning-events');
